module.exports = __webpack_public_path__ + "img/taas.3a1519eb.svg";